import React from 'react';

import $ from 'jquery';
import moment from 'moment';
import {autorun, observable, computed, action, reaction} from 'mobx';

import * as dates from '../../translate/dates';

import 'fullcalendar';
import 'fullcalendar/dist/locale/en-gb';
import 'fullcalendar/dist/fullcalendar.css';

export class AllotmentCalendar extends React.Component {
  refFullCalendar = (element) => {
    this.fullCalendarDiv = element;
  }  

  getSelectionEvent() {
    if(!this.props.observables.selection) return [];
    const {selection: {start, end}} = this.props.observables;
    return [{
      start,
      end,
      purpose: 'selection',
      order: 20,
      className: 'calendar-selection',
      editable: this.props.movableAllotment,
      startEditable: this.props.movableAllotment,
      durationEditable: this.props.movableAllotment,
    }];
  }

  getSelectedEvent() {
    if(!this.props.observables.selected) return [];
    const {selected: {start, end}} = this.props.observables;
    return [{
      start,
      end,
      purpose: 'selected',
      order: 10,
      className: 'calendar-selected',
    }];
  }

  getUPDTEvents() {
    if(!this.props.observables.updtItems) return [];
    return this.props.observables.updtItems.map(item => {
      return {
        start: item.start,
        end: item.end,
        rendering: 'background',
        className: 'calendar-updt',
        allDay: item.allDay
      }
    });
  }

  getAlreadRentEvents() {
    if(!this.props.observables.alreadyRentItems) return [];
    return this.props.observables.alreadyRentItems.map(item => {
      return {
        start: item.start,
        end: item.end,
        rendering: 'background',
        className: 'calendar-already-rent',
        allDay: item.allDay,
      }
    });
  }

  getEvents = () => {
    return [
      ...this.getSelectedEvent(),
      ...this.getSelectionEvent(),
      ...this.getUPDTEvents(),
      ...this.getAlreadRentEvents(),
    ];
  }

  componentDidMount() {
    const {selectableAllotment, movableAllotment} = this.props;
    const self = this;

    window.addEventListener('click', this.handleWindowClick);

    $(this.fullCalendarDiv).fullCalendar({
      aspectRatio: 1.75,
      locale: 'en-gb',

      monthNames: dates.MONTH_NAMES_LONG,
      monthNamesShort: dates.MONTH_NAMES_SHORT,
      dayNames: dates.DAY_NAMES_LONG,
      dayNamesShort: dates.DAY_NAMES_SHORT,


      allDaySlot: false,
      displayEventTime: false,
      eventOrder: function(a, b) {
        if(a.order > b.order) return 1;
        if(a.order < b.orded) return -1;
        return 0;
      },
      defaultView: this.props.observables.defaultView,
      defaultDate: this.props.observables.defaultDate,
      //selectHelper: selectableAllotment,
      selectable: selectableAllotment,
      eventDrop: (event, delta, revertFunc, jsEvent, ui, view ) => { 
        if(event.purpose === 'selection') {
          this.props.onSelectionChanged && this.props.onSelectionChanged(event)
        }
      },
      eventResize: (event, delta, revertFunc, jsEvent, ui, view ) => { 
        if(event.purpose === 'selection') {
          this.props.onSelectionChanged && this.props.onSelectionChanged(event)
        }
      },      
      events: (start, end, timezone, callback) => {
        callback(this.getEvents());
      },
      select: (start, end) => {
        this.props.onIntervalSelect && this.props.onIntervalSelect({start, end})
        $(this.fullCalendarDiv).fullCalendar('unselect');
      },
      header: {
        left: '',
        center: 'title',
        right: ''
      },
      views: {
        agendaWeekOneDay: {
          nowIndicator: true,
          type: 'agendaWeek',
          duration: {days: 7},
          buttonText: 'Week',
          dateIncrement: {days: 1},
          slotDuration: {minutes: 60},
          snapDuration: {minutes: 15},
          slotLabelFormat: 'HH:mm',
        }, 
      },
      eventAfterRender: function(event, element, view) {
        if(view.type === 'agendaWeekOneDay') {
          if(event.purpose === 'selection') {
            /*element.css({
              left: '10%',
              width: '80%',
              margin: '0px',
              'z-index': 5,
            });*/
          }
          if(event.purpose === 'selected') {
            /*element.css({
              left: '0%',
              width: '100%',
              margin: '0px',
            });*/
          }
        }
      },
      viewDestroy: (view) => {
        if (view.name=='agendaWeekOneDay') {
          var scrollEl = $(self.fullCalendarDiv).find('.fc-scroller');
          self.scrollPosition = scrollEl.scrollTop();
        }
      },
      viewRender: (view) => {
        if (view.name=='agendaWeekOneDay') {
          var scrollEl = $(self.fullCalendarDiv).find('.fc-scroller');
          scrollEl.scrollTop(this.scrollPosition);
        }
      }      
    });


    this.reEvents = reaction(
      () => this.getEvents(),
      () => {
        $(this.fullCalendarDiv).fullCalendar('refetchEvents');
      }
    );

    this.reUpdateView = reaction(
      () => [this.props.observables.defaultDate, this.props.observables.defaultView],
      ([date, view]) => {
        this.ongoingReaction = true;
        $(this.fullCalendarDiv).fullCalendar('changeView', view);
        $(this.fullCalendarDiv).fullCalendar('gotoDate', date);
        this.ongoingReaction = false;
      },
      {
        fireImmediately: true,
      }
    )
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);
    $(this.fullCalendarDiv).fullCalendar('destroy');
    this.reEvents && this.reEvents();
    this.reUpdateView && this.reUpdateView();
    this.reUserSelection && this.reUserSelection();
  }

  @action.bound handleMouseOver(event) {
    if(this.props.observables.defaultView === 'month') {
      let date = $(event.target).data('date');
      if(date) {
        this.props.onDayMouseOver && this.props.onDayMouseOver(date);
      }
    }
  }

  @action.bound handleWindowClick(event) {
    if(!this.fullCalendarDiv.contains(event.target)) {
      this.props.onOutsideClick && this.props.onOutsideClick(event);
    }
  }

  render() {
    return <div onMouseOver={this.handleMouseOver} ref={this.refFullCalendar} className="full-calendar-root"></div>
  }
}


// WEBPACK FOOTER //
// ./src/visual/component/AllotmentCalendar.js